/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  FieldValues,
  useController,
  Path,
  PathValue,
} from 'react-hook-form';
import Classic from './Classic';
import Inline from './Inline';
import DistractionFree from './DistractionFree';
import { CommonReactHookFormProps } from '../types';
import { EditorProps } from './types';

interface RHFEditorProps<
  FormFields extends FieldValues,
> extends EditorProps, CommonReactHookFormProps<FormFields> { }

function RHFEditor<FormFields extends FieldValues>(
  props: RHFEditorProps<FormFields>,
) {
  const {
    editorType,
    name,
    control,
    value,
    label,
    disabled,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleChange = (event: string) => {
    onChange(event);
  };

  const Editor = editorType === 'inline'
    ? Inline
    : editorType === 'distractionfree'
      ? DistractionFree
      : Classic;

  return (
    <Editor
      label={label}
      value={field.value}
      disabled={disabled}
      error={error}
      onChange={handleChange}
      {...rest}
    />
  );
}

export default RHFEditor;
